import { _ as s } from "./index946.mjs";
var t = s;
function _(a) {
  return t(this.__data__, a) > -1;
}
var e = _;
export {
  e as _
};
